import { IconMapPin, IconTrain } from '~/components'
import { NO_IMAGE_URL } from '~/constants'
import { twMerge } from '~/lib/utils'
import { Office, Space, Transportation } from '~/models/types'

// HACK: オフィス検索結果一覧でも同じ処理をしている。共通化する。
const convertTransportationToText = (transportation: Transportation) => {
  switch (transportation) {
    case 'WALK':
      return '徒歩'
    case 'BUS':
      return 'バス'
    default:
      return ''
  }
}

// HACK: utilsに移行する。
// 以下でも同じ処理をしている
// https://github.com/TRANCE-Tech-Capital/share-office-map-app/blob/f889cd3abe0138b3c8cf13e3a9d9459f02f11f8a/app/features/plan-detail-page/components/office-card/office-card.tsx#L15
const createTransportationInfo = (stations: Office['stations']) => {
  const stationText = stations
    .reduce<Office['stations']>((acc, current) => {
      // 駅名の重複を避ける
      if (acc.every(({ name }) => name !== current.name)) acc.push(current)
      return acc
    }, [])
    .toSpliced(2)
    .map(
      ({ name, time, transportation }) =>
        `${name}駅${convertTransportationToText(transportation)}${time}分`,
    )
    .join('、')
  return stationText
}

type PlanInfo = {
  imageSrc: string
  facilityName: string
  address: string
  transportationInfo: string
}

const transformPlanInfo = (
  office: Pick<Office, 'name' | 'address' | 'stations'>,
  plan: Space,
): PlanInfo => {
  const sortedImages = plan?.images.sort((a, b) => a.priority - b.priority)
  const firstImage =
    sortedImages &&
    (sortedImages.find((image) => image.isEyeCatch) || sortedImages[0])?.url
  return {
    facilityName: office.name,
    address: office.address,
    transportationInfo: createTransportationInfo(office.stations),
    imageSrc: firstImage || NO_IMAGE_URL,
  }
}

type PlanInfoCardProps = {
  office: Pick<Office, 'name' | 'address' | 'stations'>
  plan: Space
  className?: string
}

export const PlanInfoCard = ({
  office,
  plan,
  className,
}: PlanInfoCardProps) => {
  const { facilityName, address, transportationInfo, imageSrc } =
    transformPlanInfo(office, plan)
  return (
    <div className={twMerge('flex flex-row', 'px-0', className)}>
      <img
        alt={`${facilityName}の画像`}
        className="h-21 w-[122px] shrink-0 object-cover"
        src={imageSrc}
      />
      <div className="flex min-w-0 flex-col gap-y-0.5 px-2">
        <p className="flex-wrap text-xs font-bold leading-[130%] text-textPrimary">
          {facilityName}
        </p>
        <div className="flex flex-row items-center gap-x-1">
          <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[51px] bg-brand-bg">
            <IconMapPin className="h-[14px] w-[14px]" color="brand" />
          </div>
          <p className="truncate text-[12px]">{address}</p>
        </div>
        <div className="flex flex-row items-center gap-x-1">
          <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[51px] bg-brand-bg">
            <IconTrain className="h-[14px] w-[14px]" color="brand" />
          </div>
          <p className="truncate text-[12px]">{transportationInfo}</p>
        </div>
      </div>
    </div>
  )
}
